import PageErrorBoundary from './PageErrorBoundary';

export default PageErrorBoundary;
